import { createReducer } from "../../../common/reduxUtil";
import { GMAT_SET_USER } from "./types";

// undefined while account state loads, null when signed out.
const initialState = {
  user: undefined,
};

export default createReducer(initialState, {
  [GMAT_SET_USER]: (state, user) => ({ ...state, user }),
});
